import React, { useState, useEffect } from 'react';
import DraggableWrapper from '../../draggable-wrapper';
import DialerIncomingCall from './dialer-incoming-call';
import type { ProspectOption } from '../types';

interface DialerIncomingCallWrapperProps {
  prospect: ProspectOption;
  onAnswer?: () => void;
  onDecline?: () => void;
  initialPosition?: { x: number; y: number };
}

export const DialerIncomingCallWrapper: React.FC<DialerIncomingCallWrapperProps> = ({
  prospect,
  onAnswer,
  onDecline,
  initialPosition,
}) => {
  const [position, setPosition] = useState<
    { x: number; y: number } | undefined
  >(initialPosition);

  // Calculate top right corner position after mount
  useEffect(() => {
    if (!initialPosition && typeof window !== 'undefined') {
      const width = 300;
      const padding = 20;
      setPosition({
        x: window.innerWidth - width - padding,
        y: padding,
      });
    }
  }, [initialPosition]);

  if (!position) {
    return null; // Don't render until position is calculated
  }

  return (
    <DraggableWrapper
      className="dialer-incoming-call-wrapper"
      dragHandleSelector=".dialer-incoming-call-drag-handle"
      width={300}
      height={131}
      initialPosition={position}
      excludeLeftArea={false}
      style={{ zIndex: 1000}}
    >
      <DialerIncomingCall
        prospect={prospect}
        onAnswer={onAnswer}
        onDecline={onDecline}
      />
    </DraggableWrapper>
  );
};
